import { GET_LOGIN_REQUEST, GET_LOGIN_SUCCESS, GET_LOGIN_CLEAR } from "./type";

const initialState = {
    loginUser: null,
    error: null,
    loading: false,
};

const LoginReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_LOGIN_REQUEST:
            return {
                ...state,
                loginUser: null,
                loading: false,
                error: null,
            };
        case GET_LOGIN_SUCCESS:
            return {
                ...state,
                loginUser: action.payload,
                loading: false,
                error: null,
            };
        case GET_LOGIN_CLEAR:
            return {
                ...state,
                loginUser: null,
                loading: false,
                error: null,
            };
        default:
            return state;
    }
};

export default LoginReducer;
